import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Divider, Flex, Form, Image, Row, Select, Space } from "antd";
import { useEffect } from "react";
import { ConfiguracaoImportacaoVendaModel } from "../../../../models/configuracaoImportacaoVenda/configuracaoImportacaoVendaModel";
import { setModalCadastrarConfiguracaoImportacaoVenda } from "../../../../redux/slices/configuracaoImportacaoVenda/configuracaoImportacaoVendaSlice";
import { atualizarConfiguracaoImportacaoVenda, cadastrarConfiguracaoImportacaoVenda } from "../../../../services/configuracaoImportacaoVendaService";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { buscarEmpresa } from "../../../../services/empresaService";
import PercentNumberField from "../../../../components/PercentNumberFormat";
import dayjs from "dayjs";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";

dayjs.locale("pt-br");

const CadastroConfiguracaoImportacaoVendaModal = () => {
  //estados globais
  const configuracaoImportacaoVendaState = useAppSelector((state) => state.configuracaoImportacaoVenda);
  const empresaState = useAppSelector((state) => state.empresa);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<ConfiguracaoImportacaoVendaModel>();

  const editar = Object.values(configuracaoImportacaoVendaState.entity).length !== 0;

  useEffect(() => {
    if (empresaState.list.length === 0) dispatch(buscarEmpresa(empresaState.busca));
    if (editar) {
      form.setFieldsValue({ ...configuracaoImportacaoVendaState.entity, dataInicio: dayjs(configuracaoImportacaoVendaState.entity.dataInicio) });
    }
  }, [configuracaoImportacaoVendaState.entity]);

  const submit = (values: ConfiguracaoImportacaoVendaModel) => {
    if (editar) {
      const args: ConfiguracaoImportacaoVendaModel = { ...values, id: configuracaoImportacaoVendaState.entity.id };
      dispatch(atualizarConfiguracaoImportacaoVenda({ value: args, busca: configuracaoImportacaoVendaState.busca }));
    } else {
      dispatch(cadastrarConfiguracaoImportacaoVenda({ value: values, busca: configuracaoImportacaoVendaState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarConfiguracaoImportacaoVenda(false));
  };

  return (
    <Form form={form} onFinish={submit} layout="vertical">
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item
            label="Empresa"
            name="idEmpresa"
            rules={[
              {
                required: true,
                message: "Digite a Empresa",
              },
            ]}
          >
            <Select
              showSearch
              optionFilterProp="labelSearch"
              loading={empresaState.loading}
              style={{ width: 300 }}
              options={empresaState.list.map((a: EmpresaModel) => ({
                value: a.id,
                key: a.apelido,
                label: (
                  <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                    <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                    {a.apelido}
                  </Flex>
                ),
                labelSearch: a.apelido,
              }))}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Início"
            name="dataInicio"
            rules={[
              {
                required: true,
                message: "Digite a data de início",
              },
            ]}
          >
            <DatePicker placeholder="" format={"DD/MM/YYYY"} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <Form.Item
            label="% Venda Física (CAP)"
            name="percentualComissaoVendaFisicaCapitalizacao"
            rules={[
              {
                required: true,
                message: "Digite o % Venda Física (CAP)",
              },
            ]}
          >
            <PercentNumberField
              value={form.getFieldValue("percentualComissaoVendaFisicaCapitalizacao")}
              onChange={(value) => form.setFieldsValue({ percentualComissaoVendaFisicaCapitalizacao: value })}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="% Venda Física (ENT)"
            name="percentualComissaoVendaFisicaEntidade"
            rules={[
              {
                required: true,
                message: "Digite o % Venda Física (ENT)",
              },
            ]}
          >
            <PercentNumberField value={form.getFieldValue("percentualComissaoVendaFisicaEntidade")} onChange={(value) => form.setFieldsValue({ percentualComissaoVendaFisicaEntidade: value })} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="% Venda Online (CAP)"
            name="percentualComissaoVendaOnlineCapitalizacao"
            rules={[
              {
                required: true,
                message: "Digite o % Venda Online (CAP)",
              },
            ]}
          >
            <PercentNumberField
              value={form.getFieldValue("percentualComissaoVendaOnlineCapitalizacao")}
              onChange={(value) => form.setFieldsValue({ percentualComissaoVendaOnlineCapitalizacao: value })}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="% Venda Online (ENT)"
            name="percentualComissaoVendaOnlineEntidade"
            rules={[
              {
                required: true,
                message: "Digite o % Venda Online (ENT)",
              },
            ]}
          >
            <PercentNumberField value={form.getFieldValue("percentualComissaoVendaOnlineEntidade")} onChange={(value) => form.setFieldsValue({ percentualComissaoVendaOnlineEntidade: value })} />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default CadastroConfiguracaoImportacaoVendaModal;
